import router from '@/router';
import store from '@/store';
import queryString from 'query-string';
import NProgress from 'nprogress'; // Progress 进度条
import 'nprogress/nprogress.css'; // Progress 进度条样式
import auth from '@/utils/auth'; // 验权
import { Message } from 'element-ui';
import util from '@/utils/';

const whiteList = ['/login', '/authredirect']; // 不重定向白名单

router.beforeEach(async (to, from, next) => {
  NProgress.start(); // 开启Progress
  // 判断是否是管理员视角
  let hash = to.fullPath.split('auto'),
    link = 'auto' + (hash.length > 1 ? hash[1] : hash[0]);
  let path: any = queryString.parse(link);
  if (path.auto === 'true') {
    try {
      let opts = {};
      window.localStorage.setItem('admin-gz-token', path.gzToken);
      window.localStorage.setItem('admin-path', decodeURIComponent(path.href));
      if (path.level === '1') {
        opts = {
          token: path.orgToken,
          captcha: 'miaocode'
        };
        let orgPath = window.localStorage.getItem('admin-org-path');
          window.localStorage.removeItem('admin-org-token');
          window.localStorage.removeItem('admin-org-path');
      } else {
        opts = {
          token: path.branchToken,
          captcha: 'miaocode'
        };
        window.localStorage.setItem('admin-org-token', path.orgToken);
        window.localStorage.setItem(
          'admin-org-path',
          decodeURIComponent(path.orgHref)
        );
      }
      await store.dispatch('user/branchLogin', opts);
      next('/school/manage/detailTab');
    } catch (e) {
      Message.error('验证失败,请重新登录');
      next({ path: '/login' });
    }
    return;
  }
  if (auth.getToken()) {
    // 判断是否有token
    if (to.path === '/login') {
      next({ path: '/' });
      NProgress.done(); // router在hash模式下 手动改变hash 重定向回来 不会触发afterEach 暂时hack方案 ps：history模式下无问题，可删除该行！
    } else {
      // 直接使用store.state.user.xxx会抛出异常，属于Vuex在TS兼容上的漏洞
      // 故使用store.getters['user']
      if (!store.getters['user'].userInfo.id) {
        try {
          await store.dispatch('user/getUserInfo');
          store.getters['user'].userInfo.id && next({ ...to });
        } catch (err) {
          try {
            await store.dispatch('user/quit');
          } catch (err) {
            auth.removeToken();
          } finally {
            Message.error('验证失败,请重新登录');
            next({ path: '/login' });
          }
        }
      } else {
        // 没有动态改变权限的需求可直接next() 删除下方权限判断 ↓
        if (util.hasAuth(store.getters.userRole, to.meta.roles || ['0'])) {
          next(); //
        } else {
          next({ path: '/error/404' });
          NProgress.done(); // router在hash模式下 手动改变hash 重定向回来 不会触发afterEach 暂时hack方案 ps：history模式下无问题，可删除该行！
        }
        // 可删 ↑
      }
    }
  } else {
    if (whiteList.indexOf(to.path) !== -1) {
      // 在免登录白名单，直接进入
      next();
    } else {
      next('/login'); // 否则全部重定向到登录页
      NProgress.done(); // router在hash模式下 手动改变hash 重定向回来 不会触发afterEach 暂时hack方案 ps：history模式下无问题，可删除该行！
    }
  }
});

router.afterEach(() => {
  NProgress.done(); // 结束Progress
});
